// 전역 UI 상태
//
// store/index.js 가 이 조각들을 펼쳐 하나의 루트 스토어로 합친다.
// Vuex 의 modules 옵션이 아니라 "조각"인 이유: Vuex 는 namespaced 여부와 무관하게
// 모듈 state 를 모듈 이름 아래에 중첩시킨다. 진짜 모듈로 바꾸면 store.state.tasks 가
// store.state.tasks.tasks 가 되어 소비자 40곳을 전부 고쳐야 한다.
// 조각 합성은 동작이 100% 동일하면서 파일만 나눈다.

// error 는 아무 화면도 읽지 않는다 — 실패는 각 호출부가 ElMessage 로 알린다. events · locations · sales 조각이
// 아직 SET_ERROR 를 커밋하고 있어 뮤테이션만 남겨 둔다(그 커밋들이 빠지면 이 파일째 지워도 된다).
export const state = {
  error: null
}

export const mutations = {
  SET_ERROR(state, error) {
    state.error = error
  }
}
